import { useRef, useState } from "react"

import { getDailyData } from "@/features/logistics/api/getDailyData"
import { getMonthlyData } from "@/features/logistics/api/getMonthlyData.ts"
import DailyChartDisplay from "@/features/logistics/components/DailyChartDisplay.tsx"
import DailyDisplay from "@/features/logistics/components/DailyDisplay"
import LogisticsMap from "@/features/logistics/components/map/LogisticsMap"
import MonthlyDisplay from "@/features/logistics/components/MonthlyDisplay.tsx"
import SPLFarmHeader from "@/features/logistics/components/SPLFarmHeader"
import TripOverview from "@/features/logistics/components/TripOverview.tsx"
import type { DailyChartConfig } from "@/features/logistics/types/dailyChartTypes.ts"

import type { MapRef } from "react-map-gl/maplibre"

export default function SPL() {
  const chartConfig: DailyChartConfig = {
    days: 14,
    kpis: [
      {
        $type: "basic",
        id: 10,
        location: 3,
        typeId: 1,
      },
      {
        $type: "basic",
        id: 300,
        location: 3,
        typeId: 1,
      },
      {
        $type: "basic",
        id: 310,
        location: 3,
        typeId: 1,
      },
      {
        $type: "basic",
        id: 320,
        location: 3,
        typeId: 1,
      },
    ],
  }

  const [selectedFarm, setSelectedFarm] = useState<number | null>(null)
  const mapRef = useRef<MapRef>(null)
  // const onFarmSelect = useCallback(
  //   (id: number, longitude: number, latitude: number) => {
  //     mapRef.current?.flyTo({
  //       center: [longitude, latitude],
  //       duration: 2000,
  //       zoom: 14,
  //     });
  //     setSelectedFarm(id);
  //   },
  //   []
  // );

  return (
    <>
      <SPLFarmHeader />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <DailyDisplay fetcher={getDailyData} />
        <MonthlyDisplay fetcher={getMonthlyData} />
        <LogisticsMap mapRef={mapRef} farm={selectedFarm} setFarm={setSelectedFarm} />
        <DailyChartDisplay config={chartConfig} />
        <TripOverview />
      </div>
    </>
  )
}
